export default "./src/client/components/auth/login/open-web/eidas-button/img/ficep-it-eidas-db.svg?a2767260ffb6d5501033651e33f2aa2e";